export enum ThemeEnum {
  DARK = 'dark',
  LIGTH = 'light'
}
